import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import RecurringPayment from './model';

/*
    NEW VOUCHERS
*/

export interface APIVoucher {
    recurringPayment: {
        amount: number;
        firstPeriod: {
            from: string;
            to: string;
        };
        lastPeriod: {
            from: string;
            to: string;
        };
        recurrence: 'MONTHLY' | 'WEEKLY'; // Bi-weekly is not yet supported.
        firstPayment: string;
        voucherCompany: {
            voucherCompanyId: string;
        };
    };
}

export const createVoucher = (institutionId: string, billPayerId: string, voucherData: APIVoucher) => {
    return RESTClient.postAuthenticatedObservable(
        `v2/invoicing/${institutionId}/${billPayerId}/vouchers`,
        voucherData,
    ).map(response => {
        return {
            payment: RecurringPayment.fromAPI(response.recurringPayment),
        };
    });
};

export interface APIUpdateVoucher {
    recurringPayment: {
        lastPeriod: {
            from: string;
            to: string;
        };
    };
}

export const updateVoucher = (
    institutionId: string,
    billPayerId: string,
    recurringPaymentId: string,
    updatedVoucher: APIUpdateVoucher,
) => {
    return RESTClient.putAuthenticatedObservable(
        `v2/invoicing/${institutionId}/${billPayerId}/vouchers/${recurringPaymentId}`,
        updatedVoucher,
    ).map(response => {
        return {
            updatedPayment: RecurringPayment.fromAPI(response.recurringPayment),
        };
    });
};

/*
    LEGACY VOUCHERS
*/

export const fetchPayments = (institutionId: string, billPayerId: string) => {
    return RESTClient.getAuthenticatedObservable(`v2/invoicing/${institutionId}/${billPayerId}/recurringPayments`).map(
        data => ({
            recurringPayments: data.recurringPayments.map(RecurringPayment.fromAPI),
            behaviors: new BehaviorsCollection(data.behaviors),
        }),
    );
};

export const createPayment = (institutionId: string, billPayerId: string, recurringPayment: any) => {
    return RESTClient.postAuthenticatedObservable(`v2/invoicing/${institutionId}/${billPayerId}/recurringPayments`, {
        recurringPayment,
    }).map(data => ({
        payment: RecurringPayment.fromAPI(data.recurringPayment),
    }));
};

export const updatePayment = (institutionId: string, billPayerId: string, paymentId: string, recurringPayment: any) => {
    return RESTClient.putAuthenticatedObservable(
        `v2/invoicing/${institutionId}/${billPayerId}/recurringPayments/${paymentId}`,
        {recurringPayment},
    ).map(data => ({
        payment: RecurringPayment.fromAPI(data.recurringPayment),
    }));
};

export const deletePayment = (institutionId: string, billPayerId: string, paymentId: string) => {
    return RESTClient.deleteAuthenticatedObservable(
        `v2/invoicing/${institutionId}/${billPayerId}/recurringPayments/${paymentId}`,
    );
};

export const denyPayment = (institutionId: string, billPayerId: string, paymentId: string, recurrenceId: string) => {
    return RESTClient.deleteAuthenticatedObservable(
        `v2/invoicing/${institutionId}/${billPayerId}/recurringPayments/${paymentId}/${recurrenceId}`,
    );
};
